import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { RunManualTaskForm } from '@/components/forms/RunManualTaskForm/RunManualTaskForm'
import { RunManualTaskFormFields } from '@/components/forms/RunManualTaskForm/RunManualTaskFormFields'

export interface RunManualTaskModalProps extends DialogProps {}

export const RunManualTaskModal: React.FC<RunManualTaskModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <RunManualTaskForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Run Scheduled Task</DialogTitle>
                  <DialogDescription>Select a task to run it.</DialogDescription>
                </DialogHeader>
                <div className="my-6">
                  <RunManualTaskFormFields />
                </div>
                <DialogFooter>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </RunManualTaskForm>
      </DialogContent>
    </Dialog>
  )
}
